import { CaseSourceType, ChannelType } from './enums'

export const channelTypeToCaseSourceType: Record<ChannelType, CaseSourceType> = {
  [ChannelType.AutomatedHotline]: CaseSourceType.AutomatedHotline,
  [ChannelType.LiveHotline]: CaseSourceType.LiveHotline,
  [ChannelType.AiHotline]: CaseSourceType.AiHotline,
  [ChannelType.ReportingSystem]: CaseSourceType.ReportingSystem,
  [ChannelType.Survey]: CaseSourceType.Survey,
}
